import { css } from '@emotion/react'
import { ExternalStyles, Text } from 'bold-ui'

import { NewsContentProps } from './news-commons'

interface NewsListProps extends NewsContentProps {
  style?: ExternalStyles
}

export function NewsList(props: Readonly<NewsListProps>) {
  const { children, style } = props
  return (
    <Text component='ul' style={[styles.noMarginUl, style]}>
      {children}
    </Text>
  )
}

const styles = {
  noMarginUl: css`
    margin: 0;
  `,
}
